import React, { useEffect } from 'react';
import { useProfileStore } from '../../state/profileStore';
import { useParams, useNavigate } from 'react-router-dom';
import UserProfile from './userprofile';

function NewUserProfile() {
  const { id } = useParams();
  const navigate = useNavigate();
  const user = useProfileStore((s) => s.profile);

  useEffect(() => {
    // If user has first and last name, redirect to named profile.
    // Brett's call 2026-05-26: keep the user's name in the URL bar for
    // visibility/UX parity — English users see /profile/john_smith and
    // Thai users should see /profile/ศิริพร_วงษ์สุวรรณ. We DID briefly strip
    // the slug to avoid Chrome's URL-bar hitch on long percent-encoded
    // URLs, but the actual navigation breakage turned out to be the React
    // state-update loops (commits 4a12123 + 48c00a3). With those fixed,
    // pages load fast and clicks work — the only remaining symptom of
    // long Thai URLs is a minor cosmetic Chrome hitch when the user clicks
    // INTO the URL bar to copy/highlight, which is acceptable.
    if (user && user.u_first_name && user.u_last_name) {
      const slug = `${user.u_first_name.toLowerCase()}_${user.u_last_name.toLowerCase()}`;
      navigate(`/profile/${slug}`, { replace: true });
    }
  }, [user, navigate]);

  // If no user data or ID doesn't match, show loading
  if (!user || user.u_id !== parseInt(id)) {
    return <div className="container mx-auto w-4/5 p-6">Loading profile...</div>;
  }

  // Render the regular UserProfile component
  return <UserProfile />;
}

export default NewUserProfile;